import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { GridApi } from "ag-grid-community";
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { GrantsSummaryService } from "src/app/services/grants/grants-summary.service";

import { Subject } from "rxjs";
import { CommonService } from 'src/app/services/common.service';
import { MessageBoxComponent } from "src/app/common/message-box/message-box.component";
import { DeleteBoxComponent } from "src/app/common/delete-box/delete-box.component";
import { GrantsBudgetRecordExpenditureComponent } from './grants-budget-record-expenditure/grants-budget-record-expenditure.component';
import { UserService } from '../../../services/user.service';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { HeadService } from "src/app/services/common/headservice";
import { GrantsDatashareService } from "src/app/services/grants/grants-datashare.service";

@Component({
  selector: 'app-grants-reconciliation',
  templateUrl: './grants-reconciliation.component.html',
  styleUrls: ['./grants-reconciliation.component.scss']
})
export class GrantsReconciliationComponent implements OnInit {
  collapesedOrNot: boolean;
  userForm: UntypedFormGroup;

  columnDefs;
  operations;
  gridApi: GridApi;
  selectedRow;
  rowData;
  advanceSearch;
  allocatedamount: number;
  expenditureamount: number;
  appid: string;
  tempOperations;
  budgetTypeOptions = [];
  budgetSubTypeOptions = [];
  userType = "";
  budgetStatusOptions = [
    { value: 0, label: 'All' },    
    { value: 4, label: 'Accepted' },
    { value: 11, label: 'Allocated' },
    { value: 12, label: 'Closed' }
  ];
  permission: any;

  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: GrantsSummaryService,
    private modalService: NgbModal,
    private commonService: CommonService,
    private userService: UserService,
    private header: HeadService,
    public grantsDatashare: GrantsDatashareService
  ) { }

  ngOnInit() {
    this.NavigateToGenInfo();
    this.userType = this.userService.getUserType();
    var grantapp = this.commonService.getGrantsApp();// "8b3a39fb-99ee-44ce-8c03-c5417eb040d2";
    this.appid = grantapp.ID;
    this.tempOperations = [];

    // if (this.userType == "E") {
    //   tempOperations.push(
    //     {
    //    "name": "Edit",
    //    "id": "markExpenditure"
    //     },
    //     {
    //       "name": "View",
    //       "id": "view"
    //     }
    //   )
    // }
    // else {
    //   tempOperations.push({
    //     "name": "Close",
    //     "id": "close"
    //   })
    // }

  

    // this.operations = tempOperations.map(operation => {
    //   return operation &&
    //     (operation.id === "add" || operation.id === "view_modal")
    //     ? {
    //       name: operation.name,
    //       callback: this[operation.id],
    //       self: this,
    //       disabled: "false"
    //     }
    //     : { name: operation.name, callback: this[operation.id], self: this };
    // });

    this.advanceSearch = {
      "fields": [
        {
          "label": "Type",
          "field": "simple",
          "type": "dropdown"
        },
        {
          "label": "Sub Type",
          "field": "program_type",
          "type": "dropdown"
        },
        {
          "label": "Date From",
          "field": "request_type",
          "type": "date"
        },
        {
          "label": "Date To",
          "field": "date_from",
          "type": "date"
        },
        {
          "label": "Status",
          "field": "status",
          "type": "dropdown"
        }
      ],
      "filters": []
    };

    this.columnDefs = [
      {
        "headerName": "Type",
        "field": "BUGET_TYPE_ID_Str",
        "sort": "asc"
      },
      {
        "headerName": "Sub Type",
        "field": "BUDGET_SUB_TYPE_ID_Str"
      },
      {
        "headerName": "Total Fees",
        "field": "TOTAL_FEE_Str"
      },
      {
        "headerName": "Requested Amount",
        "field": "REQUESTED_AMOUNT_Str"
      },
      {
        "headerName": "Allocated Amount",
        "field": "ALLOCATION_AMOUNT_Str"
      },
      {
        "headerName": "Expenditure Amount",
        "field": "EXPENDITURE_AMOUNT_Str"
      },
      {
        "headerName": "Balance",
        "field": "BALANCE_Str"
      },
      {
        "headerName": "Status",
        "field": "StatuStr"
      }
    ];

    this.setSummary();
    this.getFundCategoryList();
    this.getFundSubCategoryList("null");
    this.userForm = new UntypedFormGroup({
      BUGET_TYPE_ID: new UntypedFormControl(""),
      BUDGET_SUB_TYPE_ID: new UntypedFormControl(""),
      BUDGET_STATUS: new UntypedFormControl("")
    });

    
    this.permission = this.commonService.getPagePermission("GC09").toLowerCase();
  }

  setOperations(RawData: any): any {

    debugger;
    this.setDef(this.tempOperations);
    RawData.forEach(element => {
     
      if (this.userType === "I" && element.uploadFiles.length >0) {
        let tempOperations = [
          {
            "name": "View",
            "id": "view"
          },{
            "name": "Close",
            "id": "close"
          }           
        ]
        element["Operations"] = this.setDef(tempOperations);
      } else{
        let tempOperations = [
          {
            "name": "View",
            "id": "view"
          }
        ]
        element["Operations"] = this.setDef(tempOperations);
      }

      if (this.userType == "E") {
        let tempOperations = [];
        tempOperations.push(
          {
         "name": "Edit",
         "id": "markExpenditure"
          },
          {
            "name": "View",
            "id": "view"
          }
        );
        element["Operations"] = this.setDef(tempOperations);
      }

      if (element.StatuStr === "Closed") {
        let tempOperations = [
          {
            "name": "View",
            "id": "view"
          }
        ]
        element["Operations"] = this.setDef(tempOperations);
      }
   
      
      if(this.permission == 'view'){
        let tempoperations = [
          {
            "name": "View",
            "id": "view"
          }
        ];
        element["Operations"] = this.setDef(tempoperations);
      }

    });


    return RawData;
  }

  setDef(parmoperations: any): any {
    //this.tempoperations = parmoperations;
    this.operations = parmoperations.map(operation => {
      return operation &&
        (operation.id === "add" || operation.id === "view_modal")
        ? {
          name: operation.name,
          callback: this[operation.id],
          self: this,
          disabled: "false"
        }
        : { name: operation.name, callback: this[operation.id], self: this };
    });
    return this.operations;
  }

  AdvanceSearch() {
    //this.setSearchSummary(this.userForm.value);
    var formData = this.userForm.value;
    var BUGET_TYPE_ID = "0";
    var BUDGET_SUB_TYPE_ID = "0";
    var BUDGET_STATUS = "0";

    if (formData.BUGET_TYPE_ID != null && formData.BUGET_TYPE_ID != "" && formData.BUGET_TYPE_ID != undefined) {
      BUGET_TYPE_ID = formData.BUGET_TYPE_ID;
    }
    if (formData.BUDGET_SUB_TYPE_ID != null && formData.BUDGET_SUB_TYPE_ID != "" && formData.BUDGET_SUB_TYPE_ID != undefined) {
      BUDGET_SUB_TYPE_ID = formData.BUDGET_SUB_TYPE_ID;
    }
    if (formData.BUDGET_STATUS != null && formData.BUDGET_STATUS != "" && formData.BUDGET_STATUS != undefined) {
      BUDGET_STATUS = formData.BUDGET_STATUS;
    }

    this.getFundCategoryList();

    this.summaryService.getReconsiliationsAdvanceSummary("0", "A", this.appid, BUGET_TYPE_ID, BUDGET_SUB_TYPE_ID, BUDGET_STATUS).subscribe(summary => {
      this.rowData = summary
    });

    //this.userType = this.userService.getUserType();
    //this.summaryService.getBudgetsAdvanceSummary("0", this.userType, this.appid, BUGET_TYPE_ID, BUDGET_SUB_TYPE_ID, BUDGET_STATUS).subscribe(summary => {
    //  this.rowData = summary
    //});

  }

  getFundCategoryList() {
    this.summaryService.getBudgetTypeList().subscribe((result) => {
      if (result != null) {
        this.budgetTypeOptions = result;
        this.budgetTypeOptions = [{ label: "All", value: null, checked: true }].concat(this.budgetTypeOptions);

      }
    });
  }

  getFundSubCategoryList(typeid: any) {
    this.summaryService.getBudgetSubTypeList(typeid).subscribe((result) => {
      if (result != null) {
        this.budgetSubTypeOptions = result;
        this.budgetSubTypeOptions = [{ label: "All", value: null, checked: true }].concat(this.budgetSubTypeOptions);

      }
    });
  }
  
  getSelectedValue(value: any): void {
    this.getFundSubCategoryList(value);
  }

  SearchClear() {
    this.userForm.controls["BUGET_TYPE_ID"].setValue("");
    this.userForm.controls["BUDGET_SUB_TYPE_ID"].setValue("");

    this.userForm.controls["BUDGET_STATUS"].setValue(0);
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows()
      ? this.gridApi.getSelectedRows()[0]
      : null;
  }

  onRowDoubleClicked(event) {
   const modelRef= this.modalService.open(GrantsBudgetRecordExpenditureComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: "modal-lg modal-full-height modal-right",
      animation: true
    });
    modelRef.componentInstance.Content={
      heading: "Edit",
      content: { id: this.selectedRow["ID"] }
    }
  }

  markExpenditure() {
    let modalRef = this["self"].modalService.open(
      GrantsBudgetRecordExpenditureComponent,
      {
        backdrop: false,
        keyboard: false,
        ignoreBackdropClick: true,
        windowClass: 'modal-vlg right modal-right',
        animated: true,
      });
      modalRef.componentInstance.Content = {
        heading: 'Edit',
        content: { id: this['self'].selectedRow['ID'], appid: this.appid, budgetId: this['self'].selectedRow['BUGET_TYPE_ID']}
      }
      modalRef.result.then(result => {
        this['self'].setSummary();
      });
  }

  delete() {
    this["self"].modalRef = this["self"].modalService.show(DeleteBoxComponent);
  }

  close() {
    this.allocatedamount = parseInt(this['self'].selectedRow["ALLOCATION_AMOUNT"]);
    this.expenditureamount = parseInt(this['self'].selectedRow["EXPENDITURE_AMOUNT"])

    let modalRef = this["self"].modalService.open(DeleteBoxComponent, {backdrop: false});
    modalRef.componentInstance.Content = { heading: 'Confirmation', custommessage: 'You are about to close the request. Do you want to proceed?', ProceedButtonName: "Yes", TerminateButtonName: "Cancel" };
 
    modalRef.result.then(result => {
      if (result == "okclick") {
        this['self'].summaryService.statusupdate("api/gmbudget/statusupdate/", this['self'].selectedRow['BUDGET_ID'], 12).subscribe(result => {
          this['self'].commonService.SuccessBanner("Budget request closed successfully");
          this['self'].setSummary();
        });  
      }
    });
  }

  setSummary() {
    this.summaryService.getReconsiliationsSummary("0", "A", this.appid).subscribe(summary => {
      // summary.forEach(element => {
      //   element["EXPENDITURE_AMOUNT_Str"] = (element["EXPENDITURE_AMOUNT"] == 0? '': element["EXPENDITURE_AMOUNT"]);
      // });
   
      this.rowData = this.setOperations(summary);

    });
  }

  view() {
    let modalRef = this["self"].modalService.open(
      GrantsBudgetRecordExpenditureComponent,
      {
        backdrop: false,
        keyboard: false,
        ignoreBackdropClick: true,
        windowClass: 'modal-vlg right modal-right',
        animated: true,
      });
      modalRef.componentInstance.Content = {
        heading: 'View',
        content: { id: this['self'].selectedRow['ID'], appid: this.appid }
      }
    modalRef.content.action.subscribe(result => {
      this['self'].setSummary();
    })
  }

  NavigateToGenInfo() {
      this.appid = this.commonService.appId;
      let menuModule=this.commonService.getModuleMenu();
      if (this.appid == null || this.appid == undefined || this.appid == "") {
        const modalRefAcc = this.modalService.open(MessageBoxComponent, {});
        modalRefAcc.componentInstance.Content = { heading: '', content: { heading: '', description: 'Please save General information details to navigate to Reconciliation', operation: { hasConfirm: false } } };
        modalRefAcc.result.then((result) => {
          this.router.navigate(['/home/grants/my-applications/application-ext/:' + this.appid + '/geninfocme'],
            { skipLocationChange: true, queryParams: { id: this.appid, app_ext: true, module: "grants",submodule:menuModule.module, screen_type: "my-applications" } })
        });
        return false;
      }
  }

}
